import { FC } from 'react';
import { Stack } from 'rsuite';
import { SText } from '@setvi/shared/components';
import { Box } from '@material-ui/core';
import { CloseModalIcon } from 'pages/quotes/icons';

interface EnhancerFormHeaderProps {
  onClose: () => void;
}

export const EnhancerFormHeader: FC<EnhancerFormHeaderProps> = ({
  onClose
}) => (
  <Box>
    <Stack justifyContent="space-between" alignItems="center" direction="row">
      <SText title="Add Product Manually" weight="bold" size="2xl" />
      <CloseModalIcon onClick={onClose} style={{ cursor: 'pointer' }} />
    </Stack>

    <SText
      title="FIll Product fields"
      size="sm"
      style={{ marginTop: '12px' }}
    />
  </Box>
);
